import {getId, getType} from 'apis/model/base'
import FieldsFactory from 'components/form/FieldsFactory'
import FormActionBar from 'components/form/FormActionBar'
import Pure from 'components/Pure'
import {Formik} from 'formik'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useMemo} from 'react'
import {compose, fromRenderProps, nest} from 'recompose'
import ExamContext, {ExamProvider, formSchema,} from 'views/AppLocals/Exam/ExamContext'
import ExaminationContext from 'views/AppLocals/Exam/ExaminationContext'
import {NullAsDefault, shallowDiff} from 'views/Shared'

const ExaminationSettingQuestionSets = React.memo(() => {
    const t = useTranslate()

    const {onUpdate = NullAsDefault} = useContext(ExamContext)

    const {examination} = useContext(ExaminationContext)

    const _initialValues = useMemo(() => {
        const {examination_question_sets = []} = examination || {}
        return {
            owner_type: getType(examination?.owner),
            owner_id: getId(examination?.owner),
            examination_question_sets: Array.from(
                examination_question_sets || []
            ).map((question) => ({
                exam_question_set_id: getId(question.exam_question_set),
                ...question,
            })),
        }
    }, [examination])

    const validate = (values) => {
        let errors = {}

        const {examination_question_sets} = values || {}

        if (
            _.isEmpty(examination_question_sets) ||
            _.find(examination_question_sets, ({exam_question_set}) =>
                _.isEmpty(exam_question_set)
            )
        ) {
            errors.examination_question_sets = {
                title: t('question set'),
                message: t('required field'),
                description: t('required field'),
            }
        }

        return errors
    }

    const handleSubmit = ({avatar_preview, cover_photo_preview, ...values}) => {
        onUpdate(values, {id: getId(examination)})
    }

    return (
        <div className="space-y-3 flex flex-col">
            <Formik
                validate={validate}
                validateOnMount={true}
                validateOnChange={true}
                enableReinitialize={true}
                initialValues={_initialValues}
                onSubmit={(values) => {
                    const changes = shallowDiff(values, _initialValues)
                    const {examination_question_sets} = changes || {}
                    handleSubmit(
                        _.omitBy(
                            {
                                ...changes,
                                examination_question_sets: _.isEmpty(examination_question_sets)
                                    ? undefined
                                    : JSON.stringify(
                                        Array.from(examination_question_sets).map((e) =>
                                            _.pick(e, [
                                                'value',
                                                'value_type',
                                                'exam_question_set_id',
                                            ])
                                        )
                                    ),
                            },
                            _.isUndefined
                        )
                    )
                }}>
                <React.Fragment>
                    <Pure>
                        <FieldsFactory formSchema={[formSchema.edit_question_set]}/>
                    </Pure>
                    <FormActionBar className="background"/>
                </React.Fragment>
            </Formik>
        </div>
    )
})

export default compose(
    fromRenderProps(ExaminationContext.Consumer, ({examination}) => ({
        owner_id: getId(examination),
        owner_type: getType(examination),
    }))
)(nest(ExamProvider, ExaminationSettingQuestionSets))
